<template>
  <el-tabs v-model="tabName">
    <el-tab-pane label="组织架构" name="1">
      <div class="address-list">
        <div class="doctor">
          <div class="setUp-doctor">
            <div class="search">
              <!--遮罩层 用于关闭搜索结果窗口-->
              <div v-show="showSearchResult" @click="showSearchResult = false" class="cover"></div>
              <el-input
                class="search-input"
                v-model="filterText"
                placeholder="搜索成员、部门、员工ID"
                clearable
                @focus="openSearchResult"
              />
              <div v-show="showSearchResult" class="search-result">
                <!--空显示-->
                <div
                  v-if="searchUserList.length === 0 && searchDepartmentList.length === 0"
                  class="no-result"
                >
                  没有搜索到结果
                </div>
                <div class="search-container" v-if="searchUserList.length !== 0">
                  <div class="search-title">
                    <span>成员</span>
                    <el-button
                      type="text"
                      @click="fewUser = !fewUser"
                      style="color: #909399; font-weight: normal"
                    >
                      {{ fewUser ? '显示更多' : '收起' }}
                    </el-button>
                  </div>
                  <div
                    v-for="user in searchResultUser"
                    :key="user.userid"
                    @click="postSearchResultUser(user)"
                    class="search-label"
                  >
                    <span :title="user.name" style="width: 100px">{{ user.name }}</span>
                    <span
                      :title="user.department"
                      style="width: 200px; height: 16px; font-size: 14px"
                    >
                      {{ user.department }}
                    </span>
                  </div>
                </div>
                <div class="search-container" v-if="searchDepartmentList.length !== 0">
                  <div class="search-title">
                    <span>部门</span>
                    <el-button
                      type="text"
                      @click="fewDepartment = !fewDepartment"
                      style="color: #909399; font-weight: normal"
                    >
                      {{ fewDepartment ? '显示更多' : '收起' }}
                    </el-button>
                  </div>
                  <div
                    v-for="department1 in searchResultDepartment"
                    :key="department1.id"
                    class="search-label"
                    :title="department1.name"
                    @click="postSearchResultDepartment(department1)"
                  >
                    <span style="width: 280px; height: 18px">{{ department1.name }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!--<el-button type="primary" @click="searchSubmit()" :loading="bottonLoading">搜索</el-button>-->

            <!-- <el-button style="float: right" @click="userDataExport" :loading="bottonLoading">
          导出全部数据
        </el-button> -->
            <el-dropdown
              style="float: right"
              split-button
              type="primary"
              @click="dialogUpload = true"
              @command="dropdownClick"
              v-if="showImport"
            >
              导入通讯录
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="getHistory">查看导入历史</el-dropdown-item>
                <el-dropdown-item command="getMailList">导出通讯录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <ExportProgress ref="downloadDialog"></ExportProgress>
            <div class="release-list">
              <div class="release-list-nav">
                <div class="release-list-nav-header">
                  {{ companyName + '（' + companyNum + '）' }}
                </div>
                <el-tree
                  ref="tree"
                  :load="loadNode"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  lazy
                  class="tree"
                >
                  <div
                    class="custom-tree-node"
                    slot-scope="{ node, data }"
                    style="flex: 1; height: 100%; line-height: 26px"
                    @click="searchUserByDepartment(data.id)"
                  >
                    <span v-html="data.name"></span>
                  </div>
                </el-tree>
              </div>
              <div class="release-list-content" @click="showSearchResult = false">
                <el-table
                  :data="tableSetupList"
                  style="width: 100%"
                  v-loading="tableLoading"
                  height="700"
                >
                  <el-table-column prop="name" label="姓名"></el-table-column>
                  <el-table-column prop="position" label="职务"></el-table-column>
                  <el-table-column prop="department" label="部门"></el-table-column>
                  <el-table-column prop="userid" label="企业微信ID"></el-table-column>
                  <el-table-column prop="userid" label="员工ID"></el-table-column>
                  <el-table-column prop="user_code" label="员工号"></el-table-column>
                  <el-table-column prop="mobile" label="手机"></el-table-column>
                  <el-table-column prop="email" label="邮箱"></el-table-column>
                  <el-table-column :label="item" v-for="item in attach_extend_fields" :key="item">
                    <template slot-scope="scope">
                      {{ getExtendInfo(scope.row.user_extend_info, item) }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <el-pagination
              class="pagination"
              style="background-color: #ffffff"
              layout="total, prev, sizes, pager, next, jumper"
              :total="pageTotal"
              :page-sizes="g_pageSizesConfig"
              :page-size="pageSize"
              :current-page.sync="currentPage"
              @current-change="doctorhandleCurrentChange"
              @size-change="handleSizeChange"
            />
          </div>
        </div>
        <el-dialog
          v-loading="uploadLoading"
          class="release-dialog"
          :visible.sync="dialogUpload"
          :center="true"
          @closed="uploadClose"
        >
          <div>
            <el-upload
              ref="upload"
              class="upload"
              drag
              :http-request="handleRequest"
              :before-upload="beforeAvatarUpload"
              multiple
              action=""
              :on-remove="handleRemove"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                参照模板整理文件，可将文件拖拽到此区域，或
                <em>{{ flieUrl === '' ? '点击上传' : '点击重新上传' }}</em>
              </div>
              <div class="el-upload__tip" slot="tip">目前仅支持xlsx格式</div>
            </el-upload>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button
              :loading="isImportLoading"
              style="width: 200px"
              @click="importFileCheck"
              :disabled="flieUrl === ''"
            >
              导入
            </el-button>
            <el-button style="position: absolute" type="text" @click="getImportExcel">
              下载模板
            </el-button>
          </span>
        </el-dialog>
        <!-- 导入成功/失败 -->
        <el-dialog class="release-dialog" :visible.sync="dialogUploadStatus" :center="true">
          <div>
            <div class="upload-title">导入成功</div>
            <div class="upload-text">
              新增{{ uploadStatus.add_count }}人;更新{{ uploadStatus.update_count }}人;删除{{
                uploadStatus.delete_count
              }}人;无变化{{ uploadStatus.unchanged_count }}人
            </div>
          </div>
        </el-dialog>
        <!-- 导入历史 -->
        <el-dialog title="导入记录" class="release-dialog" :visible.sync="dialogUploadHistory">
          <div v-loading="isHistoryLoading">
            <el-table :data="uploadHistoryData" border style="width: 100%">
              <el-table-column label="导入时间" width="180">
                <template slot-scope="scope">
                  <!-- 后台返的不是北京时间, 需要减去8小时 -->
                  {{
                    $moment(scope.row.import_time * 1000 - 8 * 60 * 60 * 1000).format(
                      'YYYY-MM-DD HH:mm:ss',
                    )
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="import_user" label="导入人员" width="180"></el-table-column>
              <el-table-column prop="add_count" label="新增"></el-table-column>
              <el-table-column prop="update_count" label="更新"></el-table-column>
              <el-table-column prop="delete_count" label="删除"></el-table-column>
              <el-table-column prop="unchanged_count" label="无更改"></el-table-column>
              <el-table-column label="导入状态">
                <template slot-scope="scope">
                  {{ scope.row.import_status | importStatus }}
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    :disabled="scope.row.import_status === 7 || scope.row.import_status === 8"
                    type="text"
                    size="small"
                    @click="setDetailId(scope)"
                  >
                    查看详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="pagination"
              style="margin-top: 10px; text-align: right"
              layout="total, prev, sizes, pager, next, jumper"
              :total="historyTotal"
              :page-sizes="g_pageSizesConfig"
              :page-size="historysize"
              @current-change="historyCurrentChange"
              @size-change="historySizeChange"
              :current-page.sync="historyPage"
            />
          </div>
        </el-dialog>
        <!-- 历史详情 -->
        <el-dialog title="导入详情" class="release-dialog" :visible.sync="dialogHistoryDetail">
          <div v-loading="historyDetailLoading">
            <el-table :data="historyDetailData" border style="width: 100%">
              <el-table-column
                :prop="item"
                :label="item"
                v-for="item in tableTitleList"
                :key="item"
              ></el-table-column>
              <el-table-column label="类型">
                <template slot-scope="scope">
                  {{ scope.row.operate_type | upDataFormat }}
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="pagination"
              style="margin-top: 10px; text-align: right"
              layout="total, prev, sizes, pager, next, jumper"
              :total="historyDetailTotal"
              :page-sizes="g_pageSizesConfig"
              :page-size="historyDetailSize"
              @current-change="historyDetailCurrentChange"
              @size-change="historyDetailSizeChange"
              :current-page.sync="historyDetailPage"
            />
          </div>
        </el-dialog>
        <!-- 人员所属部门不存在弹窗 -->
        <el-dialog
          title="以下人员的所属部门不存在，导入过程中会进行部门的创建"
          class="release-dialog"
          :visible.sync="dialogNewDepartment"
          :center="true"
          @close="dialogNewDepartmentClose"
        >
          <div>
            <el-table :data="newDepartmentData" border style="width: 100%" height="333">
              <el-table-column prop="userid" label="企业微信ID"></el-table-column>
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="department_name" label="部门"></el-table-column>
              <!-- <el-table-column prop="staff_code_title" label="员工号标题"></el-table-column> -->
              <el-table-column prop="staff_code_value" :label="staffCodeTitle"></el-table-column>
            </el-table>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogNewDepartment = false">取消</el-button>
            <el-button type="primary" @click="importStaff(true)">确定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="导入失败" class="release-dialog" :visible.sync="dialogUploadError">
          <div class="dialogUploadError">
            <i class="el-icon-warning"></i>
            <p>导入失败</p>
            <p v-if="importError">
              文件格式与模板不符，请
              <el-button type="text" @click="getImportExcel">下载模板</el-button>
              参照调整后重新上传
            </p>
            <p v-else>
              请点击
              <a :href="tipsFileUrl">下载文件</a>
              ，查看错误数据
            </p>
          </div>
        </el-dialog>
      </div>
    </el-tab-pane>
    <el-tab-pane label="标签" name="2">
      <labelList></labelList>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { CosMixin } from '@/mixins/cos';
import labelList from './components/LabelList';
import {
  DownloadWeComUserListByDepartmentApi,
  // UpdateWeComUserStatusApi,
  // SearchWeComUserListApi,
  // GetWeComDepartmentListApi,
  StaffImportFileCheck,
  ListImportStaffRecord,
  ImportStaff,
  GetImportStaffDetail,
  GetStaffImportExcelStencil,
  GetStaffExtendField,
  GetImportStaffRecord,
  GetWeComDepartmentById,
  GetWeComUserByName,
  GetWeComUserDetail,
  GetWeComAllUsers,
  // GetImportStaffRecord,
} from '@/api/addressList';
import { query } from '@/libs/utils/util';
import ExportProgress from '@/components/export-progress';
import config from '@/config';

export default {
  name: 'AddressList',
  components: { labelList, ExportProgress },
  filters: {
    upDataFormat(value) {
      if (!value) return '';
      switch (value) {
        case 'UPDATE':
          return '更新';
        case 'ADD':
          return '新增';
        case 'DELETE':
          return '删除';
      }
    },
    importStatus(value) {
      if (!value) return '';
      switch (value) {
        case 1:
          return '数据校验中';
        case 2:
          return '数据校验不通过';
        case 3:
          return '模板不正确';
        case 4:
          return '含有新部门';
        case 5:
          return '未知错误';
        case 6:
          return '校验通过';
        case 7:
          return '导入中';
        case 8:
          return '导入失败';
        case 9:
          return '导入成功';
      }
    },
  },
  mixins: [CosMixin],
  data() {
    return {
      tabName: '1',
      dialogUploadError: false, // 导入失败弹窗
      tipsFileUrl: '', // 数据校验失败模板链接
      staffCodeTitle: '',
      tableLoading: false, // 列表loading
      filterText: '', // 搜索框值
      searchUserList: [],
      searchDepartmentList: [],
      fewUser: true, // 是否展示更少的搜索结果
      fewDepartment: true,
      showSearchResult: false,
      nodeHead: '', // 保存的头node
      resolveHead: '', // 保存的头resolve
      req: {
        param: '', // 传参
      },
      pageTotal: 1, // 总页数
      pageSize: 0, // 每页数量
      currentPage: 1, // 页数
      tableSetupList: [], // 列表返回数据
      loginerInfo: null,
      bottonLoading: false, // button的loading
      open_type: 0,
      navigationData: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      showTree: true,
      dialogVisible: false, // 修改状态弹窗
      userStatus: 1, // 当前用户状态
      userId: '', // 当前用户id
      department: '', // 当前部门
      departmentList: [], // 当前部门列表
      defaultExpanded: [], // 默认展开树节点的id
      list: [], // 完整成员列表
      listArr: [], // 分页数组
      companyName: '', // 公司名
      companyNum: '', // 公司人数
      activeIndex: '', // 搜索成员高亮index
      dropdownText: '导入通讯录', // 下拉菜单文章
      dialogUpload: false, // 上传弹窗
      dialogUploadStatus: false, // 导入状态弹窗
      dialogUploadHistory: false, // 导入历史
      uploadStatus: {
        addNum: 0,
        updataNum: 0,
        delNum: 0,
        noUpdataNum: 0,
      },
      newDepartmentData: [], // 新部门数据
      uploadHistoryData: [], // 上传记录数据
      flieUrl: '', // 上传文件的cos地址
      historyTotal: 0, // 导入历史总条目
      historysize: 0, // 历史数据size
      historyDetailSize: 10, // 历史详情size
      dialogNewDepartment: false, // 导入含新部门弹窗
      isImportLoading: false, // 导入按钮加载
      isHistoryLoading: false, // 导入历史加载
      dialogHistoryDetail: false, // 历史详情
      historyDetailLoading: false, // 历史详情加载
      historyPage: 1,
      historyDetailPage: 1,
      tableTitleList: [],
      historyDetailData: [],
      detailId: '',
      historyDetailTotal: 0,
      attach_extend_fields: [],
      uploadLoading: false,
      importError: false, // 未捕获到的导入错误
    };
  },
  computed: {
    searchResultUser() {
      // 用于展开和收起，展示部分或全部搜索结果
      if (this.fewUser) {
        return this.searchUserList.slice(0, 3);
      }
      return this.searchUserList;
    },
    searchResultDepartment() {
      if (this.fewDepartment) {
        return this.searchDepartmentList.slice(0, 3);
      }
      return this.searchDepartmentList;
    },
    showImport() {
      // hr隐藏导入
      return config.apiProduct !== 2001;
    },
  },
  watch: {
    filterText(val) {
      if (val) {
        this.searchName();
      } else {
        this.showSearchResult = false;
      }
    },
  },
  created() {
    if (query('tabName')) {
      this.tabName = query('tabName');
    }
    GetStaffExtendField()
      .then((res) => {
        this.attach_extend_fields = res.attach_extend_fields;
      })
      .catch((err) => {
        this.$message.error(err.message);
      }),
      (this.pageSize = this.g_pageSizeDefault);
    this.historysize = this.g_pageSizeDefault;
    this.historyDetailSize = this.g_pageSizeDefault;
  },
  methods: {
    getExtendInfo(list, property) {
      console.log(list);
      console.log(property);
      for (const item of list) {
        if (item.property_name === property) {
          return item.property_value;
        }
      }
    },
    // 新部门提示弹窗关闭钩子
    dialogNewDepartmentClose() {
      this.dialogUpload = false;
    },
    // 下载模板
    getImportExcel() {
      GetStaffImportExcelStencil({ type: 0 })
        .then((res) => {
          // res.excel_stencil
          if (!res) return;
          const a = document.createElement('a');
          a.download = '通讯录模板.xlsx';
          a.href = res.excel_stencil;
          a.click();
          this.$message.success('下载成功');
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 历史详情换长度
    historyDetailSizeChange(val) {
      this.historyDetailSize = val;
      this.getHistoryDetail();
    },
    // 历史详情换页
    historyDetailCurrentChange(val) {
      this.historyDetailPage = val;
      this.getHistoryDetail();
    },
    // 获取历史详情id
    setDetailId(scope) {
      this.detailId = scope.row.id;
      this.dialogHistoryDetail = true;
      this.getHistoryDetail();
    },
    // 历史详情
    getHistoryDetail() {
      this.historyDetailLoading = true;
      GetImportStaffDetail({
        record_id: this.detailId,
        page_size: this.historyDetailSize,
        page_index: this.historyDetailPage,
      })
        .then((res) => {
          this.historyDetailLoading = false;
          this.tableTitleList = res.content_order;
          this.historyDetailTotal = res.total;
          this.historyDetailData = res.list.map((it) => {
            try {
              const obj = JSON.parse(it.change_content);
              obj['性别'] = obj['性别'] === '1' ? '男' : '女';
              if (obj['禁用状态'] !== undefined) {
                switch (obj['禁用状态']) {
                  case '1':
                    obj['禁用状态'] = '已激活';
                    break;
                  case '2':
                    obj['禁用状态'] = '已禁用';
                    break;
                  case '4':
                    obj['禁用状态'] = '已激活';
                    break;
                  case '5':
                    obj['禁用状态'] = '退出企业';
                    break;
                }
              }
              return { ...obj, ...it };
            } catch {
              return {};
            }
          });
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 导入历史
    getImportHistory() {
      this.isHistoryLoading = true;
      ListImportStaffRecord({
        page_size: this.historysize,
        page_index: this.historyPage,
      })
        .then((res) => {
          this.historyTotal = res.total;
          this.uploadHistoryData = res.list;
          this.isHistoryLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isHistoryLoading = false;
          this.$message.error(err.message);
        });
    },
    // 导入
    importStaff(autoCreateDept = false) {
      this.uploadLoading = true;
      ImportStaff({ record_id: this.recordId, auto_create_dept: autoCreateDept })
        .then((res) => {
          if (res.status === 9) {
            this.uploadLoading = false;
            this.dialogUpload = false;
            this.dialogNewDepartment = false;
            // this.getWeComDepartmentUserList(this.navigationData[0]);

            this.nodeHead.childNodes = []; // 把存起来的node的子节点清空，不然会界面会出现重复树！
            this.loadNode(this.nodeHead, this.resolveHead); // 再次执行懒加载的方法

            this.uploadStatus = res;
            this.dialogUploadStatus = true;
            // if (this.filterText === '') {
            //   this.getWeComDepartmentUserList(this.department);
            // } else {
            //   this.seachSubmit();
            // }
          } else if (res.status === 7) {
            this.uploadLoading = true;
            let waitingTime = 0;
            const time = setInterval(() => {
              waitingTime += 1;
            }, 1000);
            const staffRecord = setInterval(() => {
              GetImportStaffRecord({ record_id: this.recordId })
                .then((res) => {
                  if (res.import_status === 9) {
                    clearInterval(staffRecord);
                    clearInterval(time);
                    this.dialogUpload = false;
                    this.dialogNewDepartment = false;
                    this.uploadLoading = false;
                    this.uploadStatus = res;
                    this.dialogUploadStatus = true;
                    this.nodeHead.childNodes = []; // 把存起来的node的子节点清空，不然会界面会出现重复树！
                    this.loadNode(this.nodeHead, this.resolveHead); // 再次执行懒加载的方法
                  } else if (res.import_status === 8) {
                    clearInterval(staffRecord);
                    clearInterval(time);
                    this.uploadLoading = false;
                    this.$message.error(res.status_msg);
                  } else if (waitingTime >= 240) {
                    clearInterval(staffRecord);
                    clearInterval(time);
                    this.uploadLoading = false;
                    this.$message('导入时间较长，请稍后刷新页面查看');
                  }
                })
                .catch((err) => {
                  clearInterval(staffRecord);
                  this.uploadLoading = false;
                  this.$message.error(err.message);
                });
            }, 2000);
          } else {
            this.dialogUpload = false;
            this.uploadLoading = false;
            this.$message.error(res.status_msg || '导入失败，请稍后再试');
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        })
        .finally(() => {
          this.$refs.upload.clearFiles();
          this.flieUrl = '';
          this.isImportLoading = false;
          // this.uploadLoading = false;
        });
    },
    // 导入校验
    importFileCheck() {
      this.isImportLoading = true;
      StaffImportFileCheck({
        import_file_url: this.flieUrl,
      })
        .then((res) => {
          this.recordId = res.record_id;
          if (res.status === 6) {
            this.importStaff();
          } else if (res.status === 4) {
            this.dialogNewDepartment = true;
            this.newDepartmentData = res.new_department;
            this.staffCodeTitle = res.new_department[0].staff_code_title;
          } else if (res.status === 2) {
            this.tipsFileUrl = res.tips_file_url;
            this.importError = false;
            this.dialogUploadError = true;
          } else if (res.status === 7) {
            this.$message('导入成功, 数据较多会在稍后更新到页面');
          } else if (res.status === 3) {
            this.importError = true;
            this.dialogUploadError = true;
          } else if (res.status === 1) {
            this.$message('数据检验中，请耐心等待检验完毕');
            this.uploadLoading = true;
            const staffRecord = setInterval(() => {
              GetImportStaffRecord({ record_id: this.recordId }).then((res) => {
                console.log(res);
                status = res.status;
                if (res.import_status === 6) {
                  clearInterval(staffRecord);
                  this.$message('数据检验完毕，导入中');
                  this.importStaff();
                } else if (res.import_status === 4) {
                  clearInterval(staffRecord);
                  this.uploadLoading = false;
                  this.dialogNewDepartment = true;
                  this.newDepartmentData = res.new_department;
                  this.staffCodeTitle = res.new_department[0].staff_code_title;
                } else if (res.import_status === 2) {
                  clearInterval(staffRecord);
                  this.uploadLoading = false;
                  this.tipsFileUrl = res.tips_file_url;
                  this.importError = false;
                  this.dialogUploadError = true;
                } else if (res.import_status === 3) {
                  clearInterval(staffRecord);
                  this.uploadLoading = false;
                  this.importError = true;
                  this.dialogUploadError = true;
                } else if (res.import_status !== 1) {
                  this.uploadLoading = false;
                  this.$message.error(res.status_msg);
                }
              });
            }, 2000);
            // staffRecord();
          } else {
            this.$message.error(res.message);
          }
          this.isImportLoading = false;
        })
        .catch((err) => {
          this.isImportLoading = false;
          this.$message.error(err.message);
        });
    },
    // 删除上传列表
    handleRemove() {
      this.flieUrl = '';
    },
    // 上传前钩子，格式错误阻止上传
    beforeAvatarUpload(file) {
      if (!/.xlsx$/gi.test(file.name)) {
        this.$message.warning('请选择格式正确的文件');
        return false;
      }
      return true;
    },
    // 上传弹窗关闭回调
    uploadClose() {
      this.flieUrl = '';
      const { uploadFiles } = this.$refs.upload;
      if (uploadFiles.length) {
        uploadFiles.splice(0, 1);
      }
    },
    // 上传
    async handleRequest(file) {
      const { uploadFiles } = this.$refs.upload;
      if (uploadFiles.length > 1) {
        uploadFiles.splice(0, 1);
      }
      const pattern = new RegExp(
        "[%--`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——| {}【】‘；：”“'。，、？]",
      );
      this.uploadLoading = true;
      const s = file.file.name;
      let rs = '';
      for (let i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }
      const cosParams = {
        imgCosKey: `${file.file.uid}${rs}`,
        fileObject: file.file,
      };
      try {
        const res = await this.putCosObject(cosParams);
        this.flieUrl = res.data;
      } catch (err) {
        this.$message.error(err.message);
      }
      this.uploadLoading = false;
    },
    handleClick() {},
    dropdownClick(command) {
      if (command === 'getHistory') {
        this.dialogUploadHistory = true;
        this.getImportHistory();
      } else if (command === 'getMailList') {
        this.userDataExport();
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      // this.doctorhandleCurrentChange(1);
      this.getWeComDepartmentUserList();
    },
    handleHistorySizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.doctorhandleCurrentChange(1);
    },
    clearInput(val) {
      if (val === '') {
        // this.getWeComDepartmentList();
        this.list = [];
      }
    },
    deb(fn, time) {
      // 防抖函数
      const clearTimer = function () {
        fn.call();
        this.searchTimer = null;
      };

      return () => {
        if (this.searchTimer) {
          clearTimeout(this.searchTimer);
          this.searchTimer = null;
        }
        this.searchTimer = setTimeout(clearTimer, time);
      };
    },
    searchName() {
      // 搜索人员和部门
      const tempFun = this.deb(() => {
        if (this.filterText.length === 0) {
          // 避免发送为空的搜索请求
          return;
        }
        GetWeComUserByName({
          name: this.filterText,
          agent_id: this.agentId,
        })
          .then((res) => {
            console.log(res);
            this.searchUserList = res.user_detail_list || [];
            this.searchDepartmentList = res.department_detail_list || [];
            this.fewUser = true;
            this.fewDepartment = true;
            this.showSearchResult = true;
          })
          .catch((e) => {
            this.$message.error(e);
          });
      }, 300);
      tempFun();
    },
    searchUserByDepartment(id) {
      this.departmentId = id;
      this.currentPage = 1;
      this.getWeComDepartmentUserList();
    },
    // 根据部门id 获取企业微信用户列表
    getWeComDepartmentUserList() {
      // 对于搜索作防抖处理
      this.tableLoading = true;
      const tempFun = this.deb(() => {
        GetWeComAllUsers({
          department_id: this.departmentId,
          page_index: this.currentPage,
          page_size: this.pageSize,
        })
          .then((res) => {
            this.pageTotal = res.total;
            this.tableSetupList = res.user_list;
            if (this.departmentId === 0) {
              this.companyNum = res.total;
            }
          })
          .catch((e) => {
            this.$message.error(e);
          })
          .finally(() => {
            this.tableLoading = false;
          });
      }, 300);
      tempFun();
    },
    openSearchResult() {
      // 点击输入框时显示上一次的搜索结果
      if (this.filterText.length) {
        this.showSearchResult = true;
      }
    },
    postSearchResultUser(user) {
      // 点击搜索结果中的人员，表格显示详细信息
      console.log(user);
      this.tableLoading = true;
      GetWeComUserDetail({
        id: user.userid,
      })
        .then((res) => {
          console.log(res);
          this.tableSetupList = [res];
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    postSearchResultDepartment(department) {
      // 点击搜索结果部门，表格显示部门详情
      console.log(department);
      this.searchUserByDepartment(department.id);
    },
    // 历史换页
    historyCurrentChange(val) {
      this.historyPage = val;
      this.getImportHistory();
    },
    historySizeChange(val) {
      this.historysize = val;
      this.historyPage = 1;
      this.getImportHistory();
    },
    // 换页
    doctorhandleCurrentChange(val) {
      // if (this.filterText === '') {
      this.currentPage = val;
      this.getWeComDepartmentUserList();
      // } else {
      //   this.searchSubmit(val);
      // }
    },
    // 导出文档
    userDataExport() {
      this.bottonLoading = true;
      this.$refs.downloadDialog.openDialog();
      this.$refs.downloadDialog.startRidiculousProgress(15);
      DownloadWeComUserListByDepartmentApi({
        id: this.department.id,
        fetchChild: 1,
      })
        .then((res) => {
          if (!res) return;
          console.log(res);
          this.$refs.downloadDialog.finishProgress(1000);
          setTimeout(() => {
            this.g_tourl(res.data, { open: true });
          }, 1000);
          this.$message.success('导出成功');
        })
        .catch((err) => {
          this.$refs.downloadDialog.abortProgress();
          this.$message.error(err.message);
        });
      this.bottonLoading = false;
    },
    // 弹窗确认修改
    // confirm() {
    //   UpdateWeComUserStatusApi({
    //     id: this.userId,
    //     enable: this.userStatus === 1 ? 0 : 1,
    //   })
    //     .then(() => {
    //       this.getWeComDepartmentUserList();
    //       this.$message.success('修改成功');
    //       this.dialogVisible = false;
    //     })
    //     .catch((e) => {
    //       this.$message.error(e);
    //     });
    // },
    // 展示弹窗
    // openClick(id, status) {
    //   this.userId = id;
    //   this.userStatus = status;
    //   this.dialogVisible = true;
    // },
    loadNode(node, resolve) {
      // 用于tree的载入函数

      if (node.level === 0) {
        this.searchUserByDepartment(0);
        this.nodeHead = node;
        this.resolveHead = resolve;
      } else {
        this.departmentId = node.data.id;
      }

      this.getDepartments().then((data) => {
        console.log(data);
        if (data) {
          resolve([...data.department_list]);
        } else {
          resolve([]);
        }

        // 设置顶节点公司名
        if (node.level === 0) {
          this.companyName = data.department_list[0].name;
        }

        this.buttonLoading = false;
      });
    },
    // 获取部门结构树
    getDepartments() {
      return new Promise((resolve) => {
        GetWeComDepartmentById({
          agent_id: -1,
          department_id: this.departmentId,
          judge_status: 1,
        })
          .then((res) => {
            console.log(res);
            resolve(res);
          })
          .catch((e) => {
            this.$message.error(e);
            resolve();
          });
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import './index.scss';
</style>
